var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['fw-status-flag', ("fw-status-flag--" + _vm.name),
    'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify',
    { 'sw-flexbox--inline': !_vm.asBlock } ],style:(_vm.rootStyle)},[(_vm.haStatus === '')?[_c('sw-icon',{attrs:{"name":_vm.iconName,"size":_vm.iconSize,"rotate":_vm.iconRotate,"as-block":""}})]:[_vm._v(_vm._s(_vm.haStatus))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }